var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "long-arrow",
  "use": "long-arrow-usage",
  "viewBox": "0 0 900 150.787",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 900 150.787\" id=\"long-arrow\">\r\n<g id=\"long-arrow__x31_\">\r\n</g>\r\n<g id=\"long-arrow__x32_\">\r\n\t<path d=\"M891.473,83.863L891.473,83.863l-66.741,66.924l-8.468-8.094l60.754-60.011H0v-12h877.018L816.264,9.199L824.731,0\r\n\t\tl75.208,75.211L891.473,83.863z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/long-arrow.icon
// module id = 331
// module chunks = 168707334958949